import { Stack, Typography } from '@mui/material';
import { useParams } from 'react-router';

import HeaderBackground from 'targets/web/assets/images/tournament/tournament-header.png';
import { useCurrentTime } from 'targets/web/modules/display/hooks/useCurrentTime';

export const TournamentCardHeader = () => {
  const currentTime = useCurrentTime();
  const { locationName } = useParams();

  return (
    <Stack
      direction={'row'}
      sx={{
        position: 'relative',
        height: 460,
        width: '100%',
        p: 2,
        pt: 6,
        backgroundImage: `url(${HeaderBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}>
      <Typography
        sx={{
          position: 'absolute',
          bottom: 16,
          right: 16,
          fontFamily: 'RawsonBlack',
          fontSize: 30,
          color: 'common.white',
          bgcolor: 'rgba(0,0,0,0.5)',
          px: 1,
          borderRadius: 1,
        }}>
        {locationName} • {currentTime}
      </Typography>

      <Typography
        sx={{
          position: 'absolute',
          bottom: 16,
          left: 16,
          fontFamily: 'RawsonBlack',
          fontSize: 30,
          color: 'common.white',
          bgcolor: 'rgba(0,0,0,0.5)',
          px: 1,
          borderRadius: 1,
        }}>
        Happening Now
      </Typography>
    </Stack>
  );
};
